// import React, { useState, useEffect } from 'react';
import ChatMenu from './ChatMenu';
// import '../Assets/css/Sidebar.css';
// import {
//   Box,
//   Radio,
//   RadioGroup,
//   FormControlLabel,
//   FormControl,
//   FormLabel,
//   Typography,
//   IconButton,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import { useTheme, useMediaQuery } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import radio_enabled from '../Assets/imgs/radio_enabled.png';
// import radio_disabled from '../Assets/imgs/radio_disabled.png';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// const Sidebar = ({ isOpen, onClose, currentPage, sidebarOpen }) => {
//   const theme1 = useTheme();
//   const isXsScreen = useMediaQuery(theme1.breakpoints.only('xs'));
//   const isSmScreen = useMediaQuery(theme1.breakpoints.only('sm'));
//   const isMdScreen = useMediaQuery(theme1.breakpoints.only('md'));
//   const navigate = useNavigate(); 

//   const [selectedModel, setSelectedModel] = useState(
//     currentPage === 'uploadscreen' ? 'model2' : currentPage === 'ask-questions' ? 'model3' : 'model1'
    
//   );

//   useEffect(() => {
//     if (currentPage === 'uploadscreen') {
//       setSelectedModel('model2');
//       localStorage.setItem('model-selected','model2')
//       window.dispatchEvent(new Event('modelChanged')); 
//     } else if (currentPage === 'homepage') {
//       setSelectedModel('model1');
//       localStorage.setItem('model-selected','model1')
//       window.dispatchEvent(new Event('modelChanged')); 
//     } else if (currentPage === 'callreports') {
//       localStorage.setItem('model-selected','model3')
//       window.dispatchEvent(new Event('modelChanged')); 
//       setSelectedModel('model3');
//     } else if(currentPage==='ask-questions'){
//       localStorage.setItem('model-selected','model3')
//       window.dispatchEvent(new Event('modelChanged')); 
//       setSelectedModel('model3');
//     }
//     else if(currentPage==='chat-page'){
//       console.log('page',currentPage)
//       localStorage.setItem('model-selected','model1')
//       window.dispatchEvent(new Event('modelChanged')); 
//       setSelectedModel('model1');
//     }
//   }, [currentPage]);

//   const handleRadioChange = (event) => {
//     const selectedValue = event.target.value;
//     setSelectedModel(selectedValue);

//     if (selectedValue === 'model1') {
//       localStorage.removeItem('selectedAssociations');
//       localStorage.removeItem('selectedYears');
//       localStorage.removeItem('selectedMetrics')
//       navigate('/home');
//     } else if (selectedValue === 'model2') {
//       localStorage.removeItem('selectedAssociations');
//       localStorage.removeItem('selectedYears');
//       localStorage.removeItem('selectedMetrics')
//       navigate('/salescoach');
//     } else if (selectedValue === 'model3') {
//       localStorage.removeItem('selectedAssociations');
//       localStorage.removeItem('selectedYears');
//       localStorage.removeItem('selectedMetrics')
//       navigate('/ask-questions'); 
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <Box
//       sx={{
//         width: '22%',
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         height: '100%',
//         backgroundColor: 'white',
//         boxShadow: '2px 0px 5px rgba(0,0,0,0.3)',
//         zIndex: '2000',
//         display: 'flex',
//         flexDirection: 'column',
//         padding: '16px 16px 16px 20px',
//         overflowY: 'auto',
//         '@media (max-width: 600px)': {
//           width: sidebarOpen ? '98% !important' : '0 !important',
//           marginTop: '48px',
//         },
//         '@media (min-width: 600px)': {
//           marginTop: '64px',
//         },
//         '@media (max-width: 540px)': {
//           width: sidebarOpen ? '98% !important' : '0 !important',
//           marginTop: '56px',
//         },
//       }}
//     >
//       <IconButton onClick={onClose} className="close-button">
//         <CloseIcon />
//       </IconButton>
//       <FormControl component="fieldset" className="models-container">
//         <FormLabel component="legend" sx={{ marginRight: '10px' }}>
//           Select a Model
//         </FormLabel>
//         <RadioGroup
//           aria-label="model"
//           name="model"
//           value={selectedModel}
//           onChange={handleRadioChange}
//         >
//           {/* Model 1: FCA Annual Reports */}
//           <div
//   className={`model-container ${selectedModel === 'model1' ? 'active' : ''}`}
//   onClick={() => handleRadioChange({ target: { value: 'model1' } })}
//   style={{ cursor: 'pointer', padding: '10px' }} // Ensuring clickable area
// >
//   <FormControlLabel
//     value="model1"
//     control={
//       <Radio
//                   icon={<img src={radio_disabled} alt="disabled" style={{ width: 24, height: 24 }} />}
//                   checkedIcon={<img src={radio_enabled} alt="enabled" style={{ width: 24, height: 24 }} />}
                 
//                 />
//     }
//     label={
//       <span
//         style={{
//           fontWeight: 600,
//           fontFamily: "'Kumbh Sans', sans-serif",
//           padding: 0,
//           display: "inline-block",
//           color: "#3B2673",
//           marginBottom: "0.75rem",
//           fontSize: "12px",
//         }}
//       >
//         cloudmigration FAQs
//       </span>
//     }
//   />
//   <Typography variant="body2" sx={{ marginLeft: '24px', marginTop: '-15px'}}>
//     Model that is built on top of the FAQs provided by Techwave Sales Team.
//   </Typography>
// </div>

//         </RadioGroup>
//       </FormControl>
//     </Box>
//   );
// };

// export default Sidebar;


import React, { useState, useEffect } from 'react';
import '../Assets/css/Sidebar.css';
import {
  Box,
  Typography,
  IconButton,
  FormControl,
  FormLabel,
  Radio,
  FormControlLabel,
  RadioGroup
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import radio_enabled from '../Assets/imgs/radio_enabled.png';
import radio_disabled from '../Assets/imgs/radio_disabled.png';


const Sidebar = ({
  isOpen,
  onClose,
  currentPage,
  sidebarOpen,
  isAdminAuthenticated
}) => {
  const navigate = useNavigate();

  // for admin selection
  const [selectedAdminPage, setSelectedAdminPage] = useState('dashboard');

  useEffect(() => {
    if (isAdminAuthenticated) {
      if (currentPage === 'admin-dashboard') setSelectedAdminPage('dashboard');
      else if (currentPage === 'admin-settings') setSelectedAdminPage('settings');
      else if (currentPage === 'admin-users') setSelectedAdminPage('users');
    }
  }, [currentPage, isAdminAuthenticated]);

  if (!isOpen) return null;

  // ✅ handle for admin
  const handleAdminChange = (value) => {
    setSelectedAdminPage(value);
    if (value === 'dashboard') navigate('/internal/admin_dashboard');
    if (value === 'settings') navigate('/internal/admin_settings');
    if (value === 'users') navigate('/internal/admin_users');
  };

  return (
    <Box
      sx={{
        width: '22%',
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100%',
        backgroundColor: 'white',
        borderRight: '1px solid #ecebf5',
        boxShadow: '8px 0 32px rgba(26, 6, 82, 0.08)',
        zIndex: 2000,
        display: 'flex',
        flexDirection: 'column',
        padding: '16px 16px 16px 20px',
        overflowY: 'auto',
        '@media (max-width: 600px)': {
          width: sidebarOpen ? '98% !important' : '0 !important',
          marginTop: '48px',
        },
        '@media (min-width: 600px)': {
          marginTop: '64px',
        }
      }}
    >
      <IconButton onClick={onClose} className="close-button">
        <CloseIcon />
      </IconButton>

      {!isAdminAuthenticated ? (
        // ✅ ---------------- Normal User Section ----------------
        <ChatMenu onClose={onClose} />
      ) : (
        // ✅ ---------------- Admin Section ----------------
        <FormControl component="fieldset" className="models-container">
          <FormLabel component="legend" sx={{ marginRight: '10px' }}>
            Admin Menu
          </FormLabel>

          {/* DASHBOARD */}
          <div
            className={`model-container ${
              selectedAdminPage === 'dashboard' ? 'active' : ''
            }`}
            onClick={() => handleAdminChange('dashboard')}
            style={{ cursor: 'pointer', padding: '10px' }}
          >
            <FormControlLabel
              value="dashboard"
              control={
                <Radio
                  checked={selectedAdminPage === 'dashboard'}
                  icon={
                    <img
                      src={radio_disabled}
                      alt="disabled"
                      style={{ width: 24, height: 24 }}
                    />
                  }
                  checkedIcon={
                    <img
                      src={radio_enabled}
                      alt="enabled"
                      style={{ width: 24, height: 24 }}
                    />
                  }
                />
              }
              label={
                <span
                  style={{
                    fontWeight: 600,
                    fontFamily: "'Kumbh Sans', sans-serif",
                    color: '#3B2673',
                    fontSize: '12px'
                  }}
                >
                  Dashboard
                </span>
              }
            />
            <Typography
              variant="body2"
              sx={{ marginLeft: '24px', marginTop: '-15px' }}
            >
              View overall statistics and query logs.
            </Typography>
          </div>

          {/* SETTINGS */}
          <div
            className={`model-container ${
              selectedAdminPage === 'settings' ? 'active' : ''
            }`}
            onClick={() => handleAdminChange('settings')}
            style={{ cursor: 'pointer', padding: '10px' }}
          >
            <FormControlLabel
              value="settings"
              control={
                <Radio
                  checked={selectedAdminPage === 'settings'}
                  icon={
                    <img
                      src={radio_disabled}
                      alt="disabled"
                      style={{ width: 24, height: 24 }}
                    />
                  }
                  checkedIcon={
                    <img
                      src={radio_enabled}
                      alt="enabled"
                      style={{ width: 24, height: 24 }}
                    />
                  }
                />
              }
              label={
                <span
                  style={{
                    fontWeight: 600,
                    fontFamily: "'Kumbh Sans', sans-serif",
                    color: '#3B2673',
                    fontSize: '12px'
                  }}
                >
                  Application Settings
                </span>
              }
            />
            <Typography
              variant="body2"
              sx={{ marginLeft: '24px', marginTop: '-15px' }}
            >
              Configure application-level settings.
            </Typography>
          </div>

          {/* USERS */}
          <div
            className={`model-container ${
              selectedAdminPage === 'users' ? 'active' : ''
            }`}
            onClick={() => handleAdminChange('users')}
            style={{ cursor: 'pointer', padding: '10px' }}
          >
            <FormControlLabel
              value="users"
              control={
                <Radio
                  checked={selectedAdminPage === 'users'}
                  icon={
                    <img
                      src={radio_disabled}
                      alt="disabled"
                      style={{ width: 24, height: 24 }}
                    />
                  }
                  checkedIcon={
                    <img
                      src={radio_enabled}
                      alt="enabled"
                      style={{ width: 24, height: 24 }}
                    />
                  }
                />
              }
              label={
                <span
                  style={{
                    fontWeight: 600,
                    fontFamily: "'Kumbh Sans', sans-serif",
                    color: '#3B2673',
                    fontSize: '12px'
                  }}
                >
                  User Management
                </span>
              }
            />
            <Typography
              variant="body2"
              sx={{ marginLeft: '24px', marginTop: '-15px' }}
            >
              Manage application users and their roles.
            </Typography>
          </div>
        </FormControl>
      )}
    </Box>
  );
};

export default Sidebar;

